<template>
  <header>
    <div class="branding">
      <component
        :is="HearseeLogo"
        alt=""
      />
      <!-- @slot Slot for a link out of the current view, shown under the logo -->
      <slot name="navigation"></slot>
    </div>
    <div class="controls">
      <slot name="controls"></slot>
      <div class="profile-section">
        <AuthButton
          :is-authenticated="props.isAuthenticated"
          @login="emit('login')"
          @logout="emit('logout')"
        />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import HearseeLogo from '@/assets/images/logo.svg'
import AuthButton from '@/components/AuthButton/AuthButton.vue'

export interface Props {
  isAuthenticated: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (login: 'login'): void
  (logout: 'logout'): void
}>()
</script>

<style lang="scss" scoped>
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-xs) var(--spacing-regular);
}

.branding {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-minimal);
  align-items: flex-start;
}
</style>
